

export const SET_QUESTION_EVALUATING_CURRENT = "set question evaluating current";





// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_evaluating/actionType.js